import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { navigate } from "vike/client/router"
import parse from "html-react-parser"

const NoSubscriptionsCard = () => {
  const handleViewPlans = (link) => {
    if (link?.[0]?.url) {
      navigate(link[0].url)
    }
  }

  return (
    <CMSRender
      contentType="NoSubscriptionsCard"
      renderItem={(card) => {
        return (
          <div className="w-full max-w-[554px] flex flex-col items-center  lg:items-start justify-between bg-paper rounded-[50px] gap-5 md:gap-0 px-[40px] py-[35px] shadow-card_shadow">
            {/* Title */}
            <Typography 
              variant="h3" 
              className="text-text text-center lg:text-left mb-[25px] mx-auto lg:mx-0"
            >
              {card.title}
            </Typography>

            {/* Description */}
            <Typography 
              variant="body1"
              className="w-full text-center md:text-left mt-0 mb-[6px]"
            >
              {parse(card.description)}
            </Typography>

            <div className="w-full flex flex-col-reverse lg:flex-row items-center lg:items-end justify-between gap-5 lg:gap-0">
              {/* CTA Button */}
              <Button
                variant="primary_s"
                onClick={() => handleViewPlans(card.plans_btn[0]?.link)}
                className="flex-shrink-0"
              >
                {card.cta}
              </Button>

              {/* Image */}
              <img
                src={card.image}
                alt="Premium features"
                className="w-[265px] h-auto object-contain"
              />
            </div>
          </div>
        )
      }}
    />
  )
}

export default NoSubscriptionsCard
